import store from '../store'
import { login, funds } from '@/api'


const actions = {
  /**
   * ========================================================
   * ************   公共部分   ************
   * ========================================================
   */

  async getUserInfo({ commit }) {
    let info = await login.getUserInfo()
    if (info.data.IsSuccess) {
      await commit('setUserInfo', info.data.Data)

    }
  },
  //已删除  接口已废弃
  // jfdepositPage({ state, commit }, params) {
  //   console.log(params)
  //   let res = funds.jfdepositPage(params)
  //   if (res.IsSuccess) { //1 老版本 2新版本
  //     commit('setIsNewDeposit', res.Data == '2')
  //   }
  // }
}

export default actions



// WEBPACK FOOTER //
// ./src/store/actions.js